/** ----------------------------------------
     Utility
 ---------------------------------------- */

import unique from '@util/unique';

/** ----------------------------------------
     Module Interface
 ---------------------------------------- */

import module from './interface';

/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {

    /** ----------------------------------------
         All Pages
     ---------------------------------------- */

    getPages: state => {
        return state.data;
    },

    /** ----------------------------------------
        Get Page by Slug
     ---------------------------------------- */

    getPageBySlug: state => slug => {
        return state.data.filter(page => page.slug === slug)[0];
    },

};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters